/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import Table from "../reuse/Table";
import { useDataContext } from "../../context/DataContext";
import { PaginationButton, Header } from "../Styles";

function ViewRecord({ row }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PaginationButton
        type="button"
        onClick={() =>
          navigate(`/request/${row.original.id_F}`, {
            state: { row: row.original },
          })
        }
      >
        Open this request/Abrir esta solicitud
      </PaginationButton>
    </div>
  );
}

export default function Requests() {
  // const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const { data, setData } = useDataContext();

  const axiosPrivate = useAxiosPrivate();

  const [expandedRows, setExpandedRows] = useState({}); // Track expanded state for rows

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    setLoading(true);

    const getRequests = async () => {
      try {
        const response = await axiosPrivate.get("request/requests", {
          signal: controller.signal,
        });
        setData(response.data);
      } catch (err) {
        if (isMounted) {
          toast.error(
            "Failed to get request history | No se pudo obtener el historial de solicitudes",
          );
        }
      } finally {
        setLoading(false);
      }
    };

    getRequests();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  /* 
  const handleRowClick = (row) => {
    navigate(`/request/${row.original.id_F}`, { state: { row: row.original } });
  };
  */

  const toggleRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const columns = React.useMemo(
    () => [
      {
        header: "",
        id: "id_F",
        // size: 280,
        cell: (info) => <ViewRecord row={info.row} />,
      },
      {
        header: "Client Name / Nombre Cliente",
        accessorKey: "clientName_F",
        id: "clientName_F",
        size: 150,
      },
      {
        header: "Request Submitted / Solicitud Ingresada",
        accessorKey: "requestSubmitted_F",
        id: "requestSubmitted_F",
        size: 100,
      },
      {
        header: "Message / Mensaje",
        accessorKey: "messageToRequestor_F",
        id: "messageToRequestor_F",
        size: 300,
        /* cell: ({ cell }) => (
          <div dangerouslySetInnerHTML={{ __html: cell.getValue() }} />
        ), */
        cell: React.memo(({ cell, row }) => {
          /* 
          // eslint-disable-next-line react/button-has-type
          <button
            onClick={() => row.toggleExpanded()}
            style={{
              background: "none",
              border: "none",
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {row.getIsExpanded() ? "Hide" : "Show"}
          </button> */

          const isExpanded = expandedRows[row.id];
          // const { message } = row.original;
          const message = cell.getValue();
          const displayMessage = isExpanded
            ? message
            : `${message.substring(0, 65)}...`;

          return (
            <>
              <div dangerouslySetInnerHTML={{ __html: displayMessage }} />
              {message.length > 65 && (
                <span
                  onClick={() => toggleRow(row.id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      toggleRow(row.id);
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  style={{
                    color: "#0069a6",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "15px",
                    // marginLeft: "5px",
                  }}
                >
                  {isExpanded ? "Show Less" : "Show More"}
                </span>
              )}
            </>
          );
        }),
      },
    ],
    [expandedRows],
  );

  return (
    <>
      <Header>REQUEST HISTORY / HISTORIAL SOLICITUDES</Header>
      <Table
        data={data}
        columns={columns}
        // handleRowClick={handleRowClick}
        loading={loading}
      />
    </>
  );
}
